import { FC } from 'react';
import { useContextSelector } from 'use-context-selector';

import { rootElementSelector } from '@/core/store/global/app-states';
import { AppContext } from '@/core/store/global/AppProvider';
import type { CountryItem } from '@/ux-legacy/uikit/elements/elements-index';
import { CountryPicker001 } from '@/ux-legacy/uikit/elements/elements-index';

export type SignUpFieldsProps = {
  selectedCountry?: CountryItem;
  onCountryChange?: (country: CountryItem | null) => void;
  onNameChange?: (name: string) => void;
  onEmailChange?: (email: string) => void;
  onPhoneChange?: (phone: string) => void;
  onPasswordChange?: (password: string) => void;
};

export const SignUpFields: FC<SignUpFieldsProps> = ({
  selectedCountry = null,
  onCountryChange = (country) => {},
  onNameChange = (name) => {},
  onEmailChange = (email) => {},
  onPhoneChange = (phone) => {},
  onPasswordChange = (password) => {},
}) => {
  const rootElement = useContextSelector(AppContext, rootElementSelector);

  const defaultCountry = {
    name: 'Norway',
    flag: '🇳🇴',
    code: 'NO',
    dial_code: '+47',
  };

  return (
    <>
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Name
        </label>
        <div className="mt-1">
          <input
            id="name"
            name="name"
            type="text"
            autoComplete="given-name"
            required
            className="block w-full appearance-none rounded-md border border-gray-300 dark:border-gray-700 px-3 py-2 text-gray-900 placeholder-gray-400 dark:placeholder-gray-500 shadow-sm focus:border-[#E5FD6E] focus:outline-none focus:ring-[#E5FD6E] sm:text-sm"
            onChange={(event) => {
              onNameChange(event.target.value);
            }}
          />
        </div>
      </div>

      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Email address
        </label>
        <div className="mt-1">
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            className="block w-full appearance-none rounded-md border border-gray-300 dark:border-gray-700 px-3 py-2 text-gray-900 placeholder-gray-400 dark:placeholder-gray-500 shadow-sm focus:border-[#E5FD6E] focus:outline-none focus:ring-[#E5FD6E] sm:text-sm"
            onChange={(event) => {
              onEmailChange(event.target.value);
            }}
          />
        </div>
      </div>

      <div>
        <label htmlFor="phone-number" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Phone
        </label>
        <div className="mt-1 relative">
          <div className="absolute inset-y-0 left-0 flex items-center">
            <CountryPicker001
              onChange={onCountryChange}
              rootElement={rootElement}
              selected={defaultCountry}
            />
          </div>
          <input
            type="text"
            name="phone-number"
            id="phone-number"
            className="block w-full appearance-none rounded-md border border-gray-300 dark:border-gray-700 px-3 py-2 pl-28 text-gray-900 placeholder-gray-400 dark:placeholder-gray-500 shadow-sm focus:border-[#E5FD6E] focus:outline-none focus:ring-[#E5FD6E] sm:text-sm"
            placeholder="+1 (555) 987-6543"
            onChange={(event) => {
              onPhoneChange(event.target.value);
            }}
          />
        </div>
      </div>

      <div>
        <label htmlFor="password" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Password
        </label>
        <div className="mt-1">
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            className="block w-full appearance-none rounded-md border border-gray-300 dark:border-gray-700 px-3 py-2 text-gray-900 placeholder-gray-400 dark:placeholder-gray-500 shadow-sm focus:border-[#E5FD6E] focus:outline-none focus:ring-[#E5FD6E] sm:text-sm"
            onChange={(event) => {
              onPasswordChange(event.target.value);
            }}
          />
        </div>
      </div>

      <div className="flex items-center justify-between">
        {/* <div className="flex items-center">
                  <input
                    id="remember-me"
                    name="remember-me"
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 text-[#E5FD6E] focus:ring-[#E5FD6E]"
                  />
                  <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
                    Remember me
                  </label>
                </div> */}
      </div>
    </>
  );
};

export function SignUpFooter({ onSignIn = () => {} }) {
  return (
    <div>
      <div className="flex flex-row justify-center items-center space-x-1">
        <span>Already have a profile?</span>
        <button
          type="button"
          className={[
            'font-bold',
            'bg-transparent outline-none border-none shadow-none',
            // loginStatus.isLogginIn ? 'pointer-events-none' : 'cursor-pointer'
          ].join(' ')}
          onClick={(event) => {
            event.preventDefault();
            onSignIn();
          }}
        >
          <span className="h-6">Connect</span>
        </button>
      </div>
    </div>
  );
}
